import React from "react";
// UI Framework
import { TableCell } from "@mui/material";
// Common Components
import { Button } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import {
  getLiquidityManagementRecordsTable,
  cancelLog,
} from "src/Requests/imePortfolio";
// Types
import {
  ILiquidityManagementRecordsSearchParams,
  ILiquidityManagementRecordsTableReport,
} from "src/Interfaces/imePortfolio";

interface IProps {
  taskId: number;
}

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return <TableCell />;
};

const AdditionalCol: React.FC<{
  row: ILiquidityManagementRecordsTableReport;
  onAction: () => void;
}> = ({ row }) => {
  return (
    <TableCell>
      <Button
        text="انصراف"
        onClick={() => cancelLog(row.id)}
        variant="outlined"
        disabled={row.state !== 1 && row.state !== 7}
      />
    </TableCell>
  );
};

const Additional: IAdditional<ILiquidityManagementRecordsTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};

const LiquidityManagementRecordsTable: React.FC<IProps> = ({ taskId }) => {
  return (
    <div className="w-full min-w-[900px]">
      <TableTemplate<
        ILiquidityManagementRecordsSearchParams,
        ILiquidityManagementRecordsTableReport
      >
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            AdditionalBody={Additional}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="max-h-[700px] overflow-auto"
          />
        )}
        getDataTable={getLiquidityManagementRecordsTable}
        initialSearchParameters={{ taskId }}
        withSort
      />
    </div>
  );
};

export default LiquidityManagementRecordsTable;
